<template>
  <div class="LoadingUI">
    <div class="loading">
      <div class="first"></div>
      <div class="second">
        <div class="block"></div>
      </div>
      <div class="third"></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.LoadingUI {
  .loading {
    display: flex;
    font-size: 0;
    color: #000;
    gap: 0.09rem;

    .first,
    .second,
    .third {
      display: inline-block;
      float: none;
      position: relative;
      box-sizing: border-box;
      width: 0.08rem;
      height: 0.08rem;
      animation: ball-pulse-sync 0.7s infinite ease-in-out;
    }

    .first {
      background-color: var(--dts-primary-color);
      animation-delay: -0.14s;
    }

    .second {
      animation-delay: -0.07s;

      .block {
        background-color: #ea3ab0;
        width: 0.08rem;
        height: 0.08rem;
        transform: rotate(45deg);
      }
    }

    .third {
      background-color: #f2a63b;
      border-radius: 50%;
      animation-delay: 0s;
    }
  }

  @keyframes ball-pulse-sync {
    33% {
      transform: translateY(100%);
    }

    66% {
      transform: translateY(-100%);
    }

    100% {
      transform: translateY(0);
    }
  }
}
</style>
